import { ChartEmbed } from './components/ChartEmbed';

export const AnalyticsMetabaseWidget = () => {
  return <ChartEmbed />;
};
